// Port of api/fuel/app/classes/filter/search/games/filters/query/play/plays/time.php
export default {
	name: 'play.plays.time',
	priority: 52,
	require: function(config, filter) { return filter.threshold && filter.threshold.hours > 0 },
	run: function(config, filter, data, query) {
		query.having('COALESCE(SUM(p.play_length), 0)', '>=', filter.threshold.hours * 60)
	}
}
